<template>
    <div>
      <div class="row mb-2">
        <div class="col-8">
          <mdb-input v-model="search.name" :placeholder="'Tabelle durchsuchen'"></mdb-input>
        </div>
        <div class="col-4">
          <mdb-select class="input__change" v-model="arten" @change="changeZimmerart($event)" :label="$t('Suche.Wohnungsart')" ref="art" placeholder="Auswählen"></mdb-select>
        </div>
      </div>
      <table
            id="dtMaterialDesignExample"
            class="table table-striped"
            cellspacing="0"
            width="100%"
    >
        <thead>
        <tr>

            <th class="th-sm" @click="sort('name')">
              <mdb-icon fas icon="sort-up" v-if="currentSort == 'name' && currentSortDir == 'asc'" />
              <mdb-icon fas icon="sort-down" v-if="currentSort == 'name' && currentSortDir == 'desc'"/>
              {{$t('Angebot.Von')}}
            </th>
            <th class="th-sm">m²</th>
            <th class="th-sm">{{$t('Angebot.Zimmerart')}}</th>
            <th class="th-sm" @click="sort('ort')">
              <mdb-icon fas icon="sort-up" v-if="currentSort == 'ort' && currentSortDir == 'asc'" />
              <mdb-icon fas icon="sort-down" v-if="currentSort == 'ort' && currentSortDir == 'desc'"/>
              {{$t('Angebot.Ort')}}
            </th>
            <th class="th-sm" @click="sort('freiab')">
              <mdb-icon fas icon="sort-up" v-if="currentSort == 'freiab' && currentSortDir == 'asc'" />
              <mdb-icon fas icon="sort-down" v-if="currentSort == 'freiab' && currentSortDir == 'desc'"/>
              {{$t('Angebot.Freiab')}}
            </th>
            <th class="th-sm" @click="sort('freibis')">
              <mdb-icon fas icon="sort-up" v-if="currentSort == 'freibis' && currentSortDir == 'asc'" />
              <mdb-icon fas icon="sort-down" v-if="currentSort == 'freibis' && currentSortDir == 'desc'"/>
              {{$t('Angebot.Freibis')}}
            </th>
            <th class="th-sm">{{$t('Angebot.Details')}}</th>
            <th class="th-sm">{{$t('Angebot.Bearbeiten')}}</th>
            <th class="th-sm">Freigeben</th>
            <th class="th-sm">Ablehnen</th>
            <th class="th-sm">Deaktivieren</th>
            <th class="th-sm">Bearbeitung beantragen</th>
            <th class="th-sm">{{$t('Angebot.Kommentar')}}</th>
            <!--<th class="th-sm">{{$t('Angebot.Merkliste')}}</th>-->
        </tr>
        </thead>
        <tbody>

        <template class="" v-for="Angebot in filteredAngebote" >
            <single-item :settings="Settings" :Angebot="Angebot" v-bind:key="Angebot.persistence_object_identifier" :isAufMerkliste="aufMerkliste(Angebot.persistence_object_identifier)" :listOrte="listOrte"/>
        </template>
        <Show :settings="Settings" :modalActive="false" :listOrte="listOrte" ></Show>
        <Lightbox></Lightbox>
        </tbody>
        <tfoot>
        <tr>
            <th class="th-sm">{{$t('Angebot.Von')}}</th>
            <th class="th-sm">m²</th>
            <th class="th-sm">{{$t('Angebot.Zimmerart')}}</th>
            <th class="th-sm">{{$t('Angebot.Ort')}}</th>
            <th class="th-sm">{{$t('Angebot.Freiab')}}</th>
            <th class="th-sm">{{$t('Angebot.Freibis')}}</th>
            <th class="th-sm">{{$t('Angebot.Details')}}</th>
            <th class="th-sm">{{$t('Angebot.Bearbeiten')}}</th>
            <th class="th-sm">Freigeben</th>
            <th class="th-sm">Ablehnen</th>
          <th class="th-sm">Deaktivieren</th>
            <th class="th-sm">Bearbeitung beantragen</th>
            <th class="th-sm">{{$t('Angebot.Kommentar')}}</th>
            <!--<th class="th-sm">{{$t('Angebot.Merkliste')}}</th>-->
        </tr>
        </tfoot>
      </table>

    </div>

   
</template>

<script>

import { mdbIcon, mdbSpinner } from 'mdbvue';
import { mdbDatatable } from 'mdbvue';
import settings from '@/components/Settings.json';
import Show from "@/components/angebot/admin/Show";
import AngebotService from "@/services/AngebotService";
import EmailService from "@/services/EmailService";
import singleItem from '@/components/angebot/admin/AngebotItem';
import SettingService from '@/services/SettingsService';
import Lightbox from "@/components/Lightbox";
import { mapGetters } from 'vuex'

export default {
  name: "Angebote",
    components: {
      mdbIcon,
        mdbDatatable,
        singleItem,
        mdbSpinner,
        Show,
        Lightbox,

  },
  data() {
    return {
      currentSort:'name',
      currentSortDir:'asc',
        listOrte: [],
        Texte: "",
        Settings: settings,
        search: {
          name: "",
          zimmerart: ""
        }
    };
  },
  props: {
    Angebote: Array,
    user: Object,
  }, 
  methods: {
      openModal(id) {
            this.$parent.showModal(id)
      },

      emitChange(){
            this.$parent.refreshAngebote();
      },
      emitChangeMerkliste(){
          this.$parent.getMerkliste();
      },
      aufMerkliste(id){

          let value =  this.merkliste.indexOf(id);
          if(value >= 0){
              return true
          } else {
              return false
          }
      },
      changeZimmerart(event) {
        this.search.zimmerart = event;
      },
      sort:function(s) {
        //if s == current sort, reverse
        if(s === this.currentSort) {
          this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
        }
        this.currentSort = s;
      }
  },
    computed:{
        arten(){
          const all = {
            index: 99,
            value: '',
            text: 'Alle anzeigen'
          }
          let items = settings.Settings[1][this.$store.getters.lang][0].Zimmerarten;
          const newItems = [all].concat(items);
          return newItems
        },
        merkliste(){
            let merklisteIds = [];
            let merkliste = JSON.parse(localStorage.getItem("merkliste")) ;

            for (let i = 0; i < merkliste.length; i++){
                merklisteIds.push(merkliste[i]["persistence_object_identifier"]);
            }

            return merklisteIds;
        },
        filteredAngebote(){
          let a = this.Angebote.filter(item => {
            const hasName = item.name.toLowerCase().indexOf(this.search.name.toLowerCase()) > -1;
            const hasArt = item.zimmerart.indexOf(this.search.zimmerart) > -1;

            return (hasName && hasArt)
          });
          a.sort((a,b) => {
            let modifier = 1;
            if(this.currentSortDir === 'desc') modifier = -1;
            if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
            if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
            return 0;
          });
          return a
        },
      ...mapGetters([
        'places',
      ])

    },
    mounted: function () {
       // this.arten = settings.Settings[1][this.$store.getters.lang][0].Zimmerarten;
    },
    created() {
      //this.Texte = this.$locales.Texte;
    },
}

</script>
